import { AuthenticationResult } from "@azure/msal-browser/dist/response/AuthenticationResult";

export const TokenINestedAppAuthenticationService= "INestedAppAuthenticationService";
 
export interface INestedAppAuthenticationService {
    initialize(loginHint: string, clientId: string, tenantId: string, callBackUrl :string) : Promise<void>;
    ssoGetToken(scopes: string[]): Promise<string>;
    ssoGetUserIdentity(scopes: string[]): Promise<AuthenticationResult> 
}
